module.exports = __webpack_public_path__ + "static/media/map.c685b557.jpg";